import { gql } from '@apollo/client';

export const CREATE_SURVEY_RESPONSE = gql`
  mutation CreateSurveyResponse($notificationId: String, $surveyResponse: SurveyResponseInput) {
    createSurveyResponse(notificationId: $notificationId, surveyResponse: $surveyResponse) {
      id
    }
  }
`;
